import { render, staticRenderFns } from "./Naver.vue?vue&type=template&id=2ce1aad7&"
import script from "./Naver.vue?vue&type=script&lang=js&"
export * from "./Naver.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports